/* SPOTLESS — shared behaviors (vanilla, no deps)
   1. ⓘ perks overlay trên product card (delegated)
   2. Rail carousel + dots: [data-sp-rail] + [data-sp-dots]
   3. Header: solid khi cuộn, mega menu hover, mobile drawer
   4. Cart drawer: mở/đóng, AJAX add-to-cart + đổi số lượng (Section Rendering API) */
(function () {
  'use strict';

  /* Delegated listener đăng ký 1 lần dù file bị nạp lại (Lab re-render / double include);
     init theo DOM (rails, header, reveal) vẫn chạy lại mỗi lần nạp. */
  var delegated = window.__spotlessDelegated;
  window.__spotlessDelegated = true;

  /* ---- 1. Product card info overlay ---- */
  if (!delegated) document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sp-pcard__infobtn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      btn.closest('.sp-pcard').classList.toggle('is-info');
      return;
    }
    if (e.target.closest('.sp-pcard__overlay')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    document.querySelectorAll('.sp-pcard.is-info').forEach(function (c) {
      if (!c.contains(e.target)) c.classList.remove('is-info');
    });
  });

  /* ---- 2. Rails + dots ---- */
  function initRail(rail) {
    var section = rail.closest('section') || rail.closest('.shopify-section') || document;
    /* Drag-to-scroll bằng chuột (desktop/Lab) — touch đã có sẵn */
    var dragDown = false, dragMoved = false, dragX = 0, dragLeft = 0;
    rail.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      dragDown = true; dragMoved = false; dragX = e.pageX; dragLeft = rail.scrollLeft;
    });
    window.addEventListener('mousemove', function (e) {
      if (!dragDown) return;
      var dx = e.pageX - dragX;
      if (dragMoved || Math.abs(dx) > 4) { dragMoved = true; rail.scrollLeft = dragLeft - dx; e.preventDefault(); }
    });
    window.addEventListener('mouseup', function () { dragDown = false; });
    rail.addEventListener('dragstart', function (e) { if (dragDown) e.preventDefault(); });
    rail.addEventListener('click', function (e) { if (dragMoved) { e.preventDefault(); e.stopPropagation(); } }, true);

    var dots = section.querySelector('[data-sp-dots]');
    if (!dots) return;
    function pages() { return Math.max(1, Math.ceil(rail.scrollWidth / rail.clientWidth)); }
    function maxScroll() { return rail.scrollWidth - rail.clientWidth; }
    var builtN = -1;
    function build() {
      var n = pages();
      builtN = n;
      dots.innerHTML = '';
      dots.style.display = n > 1 ? '' : 'none';
      for (var i = 0; i < n; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Trang ' + (idx + 1));
          b.addEventListener('click', function () {
            var n2 = pages();
            rail.scrollTo({ left: n2 > 1 ? (maxScroll() * idx) / (n2 - 1) : 0, behavior: 'smooth' });
          });
          dots.appendChild(b);
        })(i);
      }
      update();
    }
    function update() {
      var n = pages();
      var max = maxScroll();
      var page = max > 0 ? Math.round((rail.scrollLeft / max) * (n - 1)) : 0;
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.classList.toggle('is-active', i === page);
      });
    }
    rail.addEventListener('scroll', update, { passive: true });
    /* Chỉ dựng lại dots khi BỀ RỘNG đổi (xoay máy, resize cửa sổ). Trên mobile, thanh địa chỉ
       ẩn/hiện lúc cuộn cũng fire resize — dựng lại dots ở đó làm đổi chiều cao trang giữa lúc
       cuộn → trình duyệt bù scroll → màn hình nhảy sang đoạn khác. */
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      if (pages() !== builtN) build(); else update();
    });
    build();
  }

  /* ---- 3. Header ---- */
  function initHeader() {
    var header = document.querySelector('[data-sp-header]');
    if (!header) return;

    if (header.classList.contains('sp-header--overlay')) {
      // Đo chiều cao thật để kéo hero lên đúng bằng header (fix vệt trắng khi cao ≠ 70px)
      var setH = function () { header.style.setProperty('--sp-header-h', header.offsetHeight + 'px'); };
      setH();
      /* Chỉ đo lại khi bề rộng đổi — thanh địa chỉ mobile ẩn/hiện lúc cuộn cũng fire resize. */
      var hdrW = window.innerWidth;
      window.addEventListener('resize', function () {
        if (window.innerWidth === hdrW) return;
        hdrW = window.innerWidth;
        setH();
      });
      var onScroll = function () {
        header.classList.toggle('is-solid', window.scrollY > 60);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Mega menu hover (desktop) — có delay đóng 130ms
    var trigger = header.querySelector('[data-sp-mega-trigger]');
    var mega = header.querySelector('[data-sp-mega]');
    if (trigger && mega) {
      var timer = null;
      var open = function () { clearTimeout(timer); header.classList.add('is-mega', 'is-solid-mega'); };
      var close = function () {
        clearTimeout(timer);
        timer = setTimeout(function () { header.classList.remove('is-mega', 'is-solid-mega'); }, 130);
      };
      [trigger, mega].forEach(function (el) {
        el.addEventListener('mouseenter', open);
        el.addEventListener('mouseleave', close);
      });
    }

    // Mobile drawer
    if (!delegated) document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sp-menu-open]')) document.body.classList.add('sp-menu-open');
      if (e.target.closest('[data-sp-menu-close]') || e.target.closest('[data-sp-menu-overlay]')) document.body.classList.remove('sp-menu-open');
    });
  }

  /* ---- 4. Cart drawer ---- */
  var CART_SECTION = 'spotless-cart-drawer';
  var qtySeq = 0, qtyTimers = {}, qtyAbort = null;
  /* Request so luong dang bay thi KHONG khoa nut (chu shop chot 30/10): bam tiep van duoc dem,
     va khi response ve se gui dung MOT request nua voi so cuoi cung, tinh tren HTML/key MOI
     (Shopify co the da tach line). qtyPending giu lan bam cuoi theo id on dinh cua o so luong. */
  var qtyInFlight = false, qtyPending = null;

  /* Số vòng tối đa được phép nâng lại tổng line sau khi giảm — xem sendCartUpdate */
  var RECONCILE_MAX = 3;
  /* Luat deal da doc cho tung dong (key -> {buy,get}) de tinh san cua o so luong ma khong cho mang. */
  var ruleFloor = {};

  function openCart() {
    kachingDeals(); // nạp trước luật deal, cú bấm ± đầu tiên khỏi phải chờ
    document.body.classList.add('sp-cart-open');
  }
  function closeCart() { document.body.classList.remove('sp-cart-open'); }

  function applyCartHtml(html) {
    if (!html) return false;
    var tpl = document.createElement('div');
    tpl.innerHTML = html;
    var freshCart = tpl.querySelector('[data-sp-cart]');
    var curCart = document.querySelector('[data-sp-cart]');
    if (freshCart && curCart) {
      // Móc cho module offers: chạy đồng bộ TRƯỚC khi đổi HTML để giá nó ghi đè không nhấp nháy.
      // Lỗi ở module offers không được phép chặn giỏ hiển thị.
      if (window.spotlessCartOffers && typeof window.spotlessCartOffers.decorate === 'function') {
        try { window.spotlessCartOffers.decorate(freshCart); } catch (e) { if (window.console && console.warn) console.warn('[spotless] decorate loi', e); }
      }
      curCart.innerHTML = freshCart.innerHTML;
      // Chặn click "Thanh toán" ~0.8s sau khi giỏ vừa đổi — tránh race với checkout.js (Baseform)
      // đọc cart cũ → toast "giỏ trống" khi bấm quá nhanh.
      var bf = curCart.querySelector('.bf-trigger');
      if (bf) {
        bf.classList.add('is-settling');
        setTimeout(function () { bf.classList.remove('is-settling'); }, 800);
      }
    }
    fillDealTitles();
    // Doc truoc luat deal cho cac dong 'mua N tang 1' de san cua o so luong co ngay tu cu bam dau.
    Array.prototype.forEach.call(document.querySelectorAll('[data-sp-line-qty]'), function (box) {
      var r = box.closest('.sp-cart__item');
      if (!r || !r.dataset.key) return;
      dealRuleForRow(r).then(function (rule) { if (rule) ruleFloor[r.dataset.key] = rule; });
    });
    if (freshCart && curCart) {
      var ev;
      try { ev = new CustomEvent('sp:cart:updated'); } catch (e) {
        ev = document.createEvent('CustomEvent');
        ev.initCustomEvent('sp:cart:updated', false, false, null);
      }
      document.dispatchEvent(ev);
    }
    // cập nhật badge số lượng trên header
    var count = tpl.querySelector('.sp-cart__title');
    var badge = document.querySelector('[data-sp-cart-count]');
    if (count && badge) {
      var m = count.textContent.match(/\((\d+)\)/);
      if (m) {
        badge.textContent = m[1];
        badge.hidden = m[1] === '0';
      }
    }
    return true;
  }

  function refreshCart(thenOpen) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=' + CART_SECTION : '/?sections=' + CART_SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        applyCartHtml(data[CART_SECTION]);
        if (thenOpen) openCart();
      });
  }

  /* Chữ ký của một line giỏ: cùng variant + cùng properties = cùng line (Shopify tách
     1 line thành nhiều dòng hiển thị khi ưu đãi chỉ miễn phí một phần số lượng).
     Sắp key trước khi ghép để không phụ thuộc thứ tự properties.
     Chữ ký sống sót qua mọi thay đổi số lượng, trong khi key của dòng thì đổi — nên
     đây là cách duy nhất nhận lại đúng line sau khi cập nhật. Dùng variant_id thôi là
     không đủ: khách có thể có cùng sản phẩm ở cả line thường lẫn line bundle.
     Liquid nhận diện "cùng line" theo đúng quy tắc này khi dựng data-gift-keys —
     xem snippets/spotless-cart-gift-keys.liquid; đổi bên nào thì đổi cả hai. */
  function lineSig(variantId, properties) {
    var props = properties || {};
    return variantId + '~' + Object.keys(props).sort().map(function (k) {
      return k + '=' + props[k];
    }).join(';');
  }

  /* Liquid in properties ra dạng KHÁC hẳn cart JSON: `{{ item.properties | json }}`
     cho một MẢNG CẶP [["key","value"]], và giá trị bị escape HTML (&quot; thay cho ").
     Phải chuẩn hóa về đúng dạng object như cart JSON thì hai bên mới so chữ ký được. */
  function decodeEntities(text) {
    var map = { quot: '"', '#34': '"', apos: "'", '#39': "'", amp: '&', '#38': '&', lt: '<', '#60': '<', gt: '>', '#62': '>' };
    /* Một lượt replace duy nhất: "&amp;quot;" ra "&quot;" chứ không giải mã hai lần */
    return String(text).replace(/&(quot|#34|apos|#39|amp|#38|lt|#60|gt|#62);/g, function (m, name) { return map[name]; });
  }

  function propsFromData(raw) {
    var parsed = JSON.parse(raw || '{}'), props = {};
    if (Array.isArray(parsed)) {
      parsed.forEach(function (pair) { props[decodeEntities(pair[0])] = decodeEntities(pair[1]); });
    } else {
      Object.keys(parsed).forEach(function (k) { props[decodeEntities(k)] = decodeEntities(parsed[k]); });
    }
    return props;
  }

  /* Chữ ký của một dòng giỏ trong DOM, dựng từ chính data-* mà Liquid in ra */
  function rowSig(row) {
    if (!row || !row.dataset.variantId) return null;
    try {
      return lineSig(Number(row.dataset.variantId), propsFromData(row.dataset.props));
    } catch (e) {
      // Không chặn khách — chỉ bỏ bước chỉnh lại số lượng. Nhưng phải kêu lên, vì lặng
      // lẽ bỏ qua thì lỗi "bớt 1 mà tụt 2" quay lại mà không ai biết.
      if (window.console && window.console.warn) window.console.warn('[spotless] data-props của dòng giỏ không đọc được', e);
      return null;
    }
  }

  /* ---- Luật ưu đãi combo: đọc thẳng từ app, KHÔNG khai báo lại trong theme ----
     Kaching Bundles phơi window.kachingBundlesApi.fetchDeals() trên mọi trang. Mỗi bar
     kiểu "bxgy" mô tả đủ luật: buyQuantity (mua mấy) + getQuantity (tặng mấy).
     Sửa deal trong app là giỏ hàng chạy theo ngay, không phải đụng vào theme. */
  var dealsPromise = null;

  function kachingDeals() {
    if (dealsPromise) return dealsPromise;
    var api = window.kachingBundlesApi;
    if (!api || typeof api.fetchDeals !== 'function') return Promise.resolve(null);
    dealsPromise = Promise.resolve().then(function () { return api.fetchDeals(); })
      .catch(function () { return null; });
    return dealsPromise;
  }

  /* Dòng giỏ thuộc deal nào: app ghi {"deal":<nanoId>,"bid":<id bar>,...} vào một
     line item property. Dò theo hình dạng dữ liệu thay vì theo tên property để khỏi
     phải khai báo tên đó ở đâu cả. */
  function dealRefFrom(properties) {
    var props = properties || {}, ref = null;
    Object.keys(props).forEach(function (name) {
      if (ref) return;
      var raw = props[name];
      if (typeof raw !== 'string' || raw.charAt(0) !== '{') return;
      try {
        var parsed = JSON.parse(raw);
        // App ghi mã bar là "bid" ở ưu đãi mua-N-tặng-1, "bar" ở combo nhiều sản phẩm
        var bar = parsed && (parsed.bid || parsed.bar);
        if (parsed && parsed.deal && bar) ref = { deal: parsed.deal, bar: bar };
      } catch (e) { /* property thường của khách, bỏ qua */ }
    });
    return ref;
  }

  /* Tìm đúng bar của dòng giỏ trong danh sách deal của app */
  function dealBarForRow(row) {
    var props;
    try { props = propsFromData(row && row.dataset ? row.dataset.props : null); }
    catch (e) { return Promise.resolve(null); }
    var ref = dealRefFrom(props);
    if (!ref) return Promise.resolve(null);
    return kachingDeals().then(function (deals) {
      if (!deals) return null;
      for (var i = 0; i < deals.length; i++) {
        if (deals[i].nanoId !== ref.deal) continue;
        var bars = deals[i].dealBars || [];
        for (var j = 0; j < bars.length; j++) if (bars[j].id === ref.bar) return bars[j];
      }
      return null;
    });
  }

  /* Tên gói do app đặt ("Mua 2, Tặng 1", "Combo Cạo Bền Lâu") — Liquid không đọc
     được nên render tạm rồi điền vào đây. {{product}} là placeholder của app. */
  function fillDealTitles() {
    var slots = document.querySelectorAll('[data-sp-deal-title]');
    Array.prototype.forEach.call(slots, function (slot) {
      var row = slot.closest('.sp-cart__item, .sp-cart__line');
      if (!row) return;
      dealBarForRow(row).then(function (bar) {
        var title = bar && bar.title ? String(bar.title).trim() : '';
        if (title && title.indexOf('{{') === -1) slot.textContent = title;
      });
    });
  }

  /* Luật của dòng này: { buy, get } — hoặc null nếu là hàng thường, hoặc bar kiểu
     khác (vd "Mua 1" là quantity-break, không tặng gì). */
  function dealRuleForRow(row) {
    var props;
    try { props = propsFromData(row && row.dataset ? row.dataset.props : null); }
    catch (e) { return Promise.resolve(null); }
    var ref = dealRefFrom(props);
    if (!ref) return Promise.resolve(null);
    return kachingDeals().then(function (deals) {
      if (!deals) {
        if (window.console && window.console.warn) {
          window.console.warn('[spotless] không đọc được deal từ app bundle — giỏ sẽ không tự thêm quà');
        }
        return null;
      }
      for (var i = 0; i < deals.length; i++) {
        if (deals[i].nanoId !== ref.deal) continue;
        var bars = deals[i].dealBars || [];
        for (var j = 0; j < bars.length; j++) {
          var bar = bars[j];
          if (bar.id === ref.bar && bar.dealBarType === 'bxgy' && bar.buyQuantity > 0 && bar.getQuantity > 0) {
            return { buy: bar.buyQuantity, get: bar.getQuantity };
          }
        }
      }
      return null;
    });
  }

  /* Tổng số sản phẩm phải nằm trong line để khách TRẢ TIỀN đúng `paid` món.

     App chỉ ĐÁNH DẤU món nào miễn phí chứ không tự thêm món vào giỏ — phần quà là
     đơn vị thật trong line, nên theme phải cộng vào.

     Đây là lý do trước đây tăng lên 2 mà không thấy quà: tổng line 2 và tổng line 3
     đều cho ra "2 món tính tiền", nhưng chỉ tổng 3 mới kèm quà (và rẻ hơn). Đặt tổng
     line = 2 là khách trả 400.000đ cho 2 món thay vì 360.000đ cho 3 món. */
  function lineTotalFor(paid, rule) {
    if (paid < 1) return 0;
    if (!rule || !rule.buy || !rule.get) return paid;
    return paid + Math.floor(paid / rule.buy) * rule.get;
  }

  /* Combo nhiều sản phẩm ("Combo Cạo Bền Lâu"): app thêm mỗi thành phần thành một
     line riêng. Bốn line đó chỉ có nghĩa khi đi cùng nhau — bỏ riêng hàng mua kèm
     thì combo vỡ và các món quà nhảy về giá đầy đủ, khách bớt một món mà hóa đơn
     TĂNG. Nên mọi thay đổi số lượng phải kéo cả gói.

     pairs = "key|sốlượng" của từng line trong gói, do Liquid in ra. Ngăn cách bằng
     "|" vì key đã chứa sẵn dấu ":" (dạng variantId:hash).
     Nhân theo tỉ lệ chứ không gán cùng một số, vì gói có thể chứa 2 cái của một món. */
  function bundleUpdates(pairs, baseQty, target) {
    var updates = {};
    var ratio = baseQty > 0 ? target / baseQty : 0;
    pairs.forEach(function (pair) {
      var at = pair.lastIndexOf('|');
      if (at < 1) return;
      var qty = Number(pair.slice(at + 1)) || 0;
      updates[pair.slice(0, at)] = target <= 0 ? 0 : Math.max(1, Math.round(qty * ratio));
    });
    return updates;
  }

  /* Mot mon trong combo nhieu mon co the nam tren NHIEU line (line uu dai + line gia goc do
     Shopify tach ra khi khach them). pairs = "key|qty," theo thu tu: line gia goc truoc, line uu
     dai sau. Tang: cong vao line cuoi (uu dai) — app tu tach phan them thanh gia goc. Giam: bot
     o cac line gia goc truoc, line uu dai giu lai sau cung. */
  function memberUpdates(pairsStr, target) {
    var pairs = String(pairsStr || '').split(',').filter(Boolean).map(function (p) {
      var at = p.lastIndexOf('|');
      return { key: p.slice(0, at), qty: Number(p.slice(at + 1)) || 0 };
    });
    var total = pairs.reduce(function (sum, p) { return sum + p.qty; }, 0);
    var updates = {};
    if (!pairs.length) return updates;
    if (target >= total) {
      var last = pairs[pairs.length - 1];
      updates[last.key] = last.qty + (target - total);
      return updates;
    }
    var cut = total - target;
    pairs.forEach(function (p) {
      var take = Math.min(p.qty, cut);
      cut -= take;
      updates[p.key] = p.qty - take;
    });
    return updates;
  }

  /* Tim o so luong theo id on dinh trong HTML HIEN TAI (sau moi response, HTML drawer la moi). */
  function qtyBoxById(id) {
    var boxes = document.querySelectorAll('[data-sp-cart] .sp-cart__qty');
    for (var i = 0; i < boxes.length; i++) if (boxes[i].dataset.spQtyId === id) return boxes[i];
    return null;
  }

  /* Gui request doi so luong cho o `id` toi `q`, tinh tren DOM hien tai. Khi xong (thanh cong hay
     loi), neu co lan bam doi (qtyPending) thi ap so do len HTML moi va gui tiep. */
  function runQtyUpdate(id, q) {
    var box = qtyBoxById(id);
    if (!box) { qtyInFlight = false; return; }
    var btn = box.querySelector('[data-sp-qty]');
    var key = btn ? btn.dataset.key : null;
    if (!key) { qtyInFlight = false; return; }
    var isDealStep = box.hasAttribute('data-sp-deal-qty');
    var isMemberStep = box.hasAttribute('data-sp-member-qty');
    var row = isDealStep ? box.closest('[data-bundle-keys]') : box.closest('.sp-cart__item');
    var lineGifts = row && row.dataset.giftKeys ? row.dataset.giftKeys.split(',').filter(Boolean) : [];
    var bundlePairs = bundlePairsOf(row);
    var seq = ++qtySeq;
    qtyInFlight = true;
    if (qtyAbort) qtyAbort.abort();
    qtyAbort = typeof AbortController === 'function' ? new AbortController() : null;
    var signal = qtyAbort ? qtyAbort.signal : undefined;
    var p;
    if (isMemberStep) {
      p = sendCartUpdate(memberUpdates(box.dataset.keys, q), null, seq, signal);
    } else if (bundlePairs.length) {
      p = sendCartUpdate(bundleUpdates(bundlePairs, Number(row.dataset.qty) || 0, q), null, seq, signal);
    } else {
      var sig = rowSig(row);
      // Dung lai CA line: dong tinh tien nhan tron tong can co, cac dong qua cu ve 0 roi de app chia lai.
      p = dealRuleForRow(row).then(function (rule) {
        if (rule) ruleFloor[key] = rule;
        if (seq !== qtySeq) return;
        var updates = {};
        updates[key] = lineTotalFor(q, rule);
        lineGifts.forEach(function (k) { updates[k] = 0; });
        var goal = sig ? { sig: sig, paid: q, tries: RECONCILE_MAX } : null;
        return sendCartUpdate(updates, goal, seq, signal);
      });
    }
    function finish() {
      if (seq !== qtySeq) return;
      qtyInFlight = false;
      if (!qtyPending) return;
      var pend = qtyPending; qtyPending = null;
      var nb = qtyBoxById(pend.id);
      if (nb) {
        var span = nb.querySelector('span');
        if (span) span.textContent = pend.q;
        var r = nb.closest('.sp-cart__item');
        if (r) Array.prototype.forEach.call(r.querySelectorAll('.sp-cart__item-price'), function (el) { el.classList.add('is-updating'); });
        var foot = document.querySelector('[data-sp-cart] .sp-cart__foot');
        if (foot) foot.classList.add('is-updating');
      }
      runQtyUpdate(pend.id, pend.q);
    }
    Promise.resolve(p).then(finish, finish);
  }

  function bundlePairsOf(row) {
    return row && row.dataset.bundleKeys ? row.dataset.bundleKeys.split(',').filter(Boolean) : [];
  }

  /* Số sản phẩm TÍNH TIỀN của line có chữ ký này, đọc từ JSON mà cart AJAX trả về.
     Trả null khi line không còn dòng tính tiền nào (vd vừa bị xóa hết). */
  function paidLineOf(items, sig) {
    var paid = items.filter(function (it) {
      return it.final_price > 0 && lineSig(it.variant_id, it.properties) === sig;
    });
    if (!paid.length) return null;
    return {
      key: paid[0].key,
      quantity: paid.reduce(function (sum, it) { return sum + it.quantity; }, 0)
    };
  }

  /* Gửi thay đổi giỏ, rồi NÂNG LẠI tổng line nếu số tính tiền chưa đúng đích.
     Vì sao cần: hạ tổng line xuống có thể làm ưu đãi áp lại ở mức nhỏ hơn. Giỏ
     4 tính tiền + 2 quà, bấm − là muốn còn 3 tính tiền; đặt tổng line = 3 thì lại
     vừa đủ một combo nên ra 2 tính tiền + 1 quà. Mỗi vòng cộng tổng line thêm 1 cho
     tới khi số tính tiền đúng bằng đích (4 → tổng 4 → 3 tính tiền + 1 quà).
     Chỉ render HTML ở vòng cuối nên khách không thấy số nhảy qua bước trung gian. */
  function sendCartUpdate(updates, goal, seq, signal) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: CART_SECTION }),
      signal: signal
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        if (seq !== qtySeq) return; // đã có thay đổi mới hơn đang bay
        if (goal && goal.paid > 0 && data.items) {
          var line = paidLineOf(data.items, goal.sig);
          if (!line) {
            // Không nhận ra line vừa sửa (chữ ký DOM lệch chữ ký cart JSON). Bỏ bước
            // chỉnh lại thì lỗi "bớt 1 mà tụt 2" quay lại — im lặng là hỏng ngầm.
            if (window.console && window.console.warn) {
              window.console.warn('[spotless] giỏ: không khớp được line vừa sửa nên bỏ bước chỉnh số lượng');
            }
          } else if (line.quantity < goal.paid) {
            if (goal.tries > 0) {
              var next = {};
              next[line.key] = line.quantity + 1;
              return sendCartUpdate(next, { sig: goal.sig, paid: goal.paid, tries: goal.tries - 1 }, seq, signal);
            }
            // Hết lượt mà vẫn chưa tới đích: ưu đãi có bậc khác lúc viết hàm này
            // (vd "mua 3 tặng 2"). Không chặn khách, nhưng để lại dấu vết mà lần theo.
            if (window.console && window.console.warn) {
              window.console.warn('[spotless] giỏ dừng ở ' + line.quantity + ' sản phẩm tính tiền, đích là ' + goal.paid + ' — cần tăng RECONCILE_MAX?');
            }
          }
        }
        if (!applyCartHtml(data.sections && data.sections[CART_SECTION])) return refreshCart(false);
      })
      .catch(function () { if (seq === qtySeq) refreshCart(false); });
  }

  /* Trang /cart dùng lại cách nhận diện line này (script riêng trong section) */
  window.spotlessCart = {
    paidLineOf: paidLineOf, rowSig: rowSig, lineTotalFor: lineTotalFor,
    dealRuleForRow: dealRuleForRow, bundleUpdates: bundleUpdates, fillDealTitles: fillDealTitles,
    applyCartHtml: applyCartHtml, refreshCart: refreshCart, openCart: openCart, CART_SECTION: CART_SECTION
  };

  if (!delegated) document.addEventListener('click', function (e) {
    // Nút CTA giữa trang cuộn lên khu Kaching Bundles (giống nút sticky/float trên PDP)
    var sb = e.target.closest('[data-sp-scroll-buy]');
    if (sb) {
      // Tìm y hệt nút sticky của PDP: quét TRONG section product-main (tránh dính
      // style/script id*="kaching" mà app chèn vào <head>/cuối body → rect = 0 → cuộn sai chỗ),
      // và chỉ nhận element đang hiển thị thật (có clientRect).
      var scope = document.querySelector('[id^="SpotPdp-"]') || document.getElementById('MainContent') || document.body;
      var t = null;
      var cands = scope.querySelectorAll('[class*="kaching"], [id*="kaching"], .spm-form, .spm-add');
      for (var ci = 0; ci < cands.length; ci++) {
        var c = cands[ci];
        if (c.tagName === 'SCRIPT' || c.tagName === 'STYLE' || c.tagName === 'LINK') continue;
        if (c.getClientRects().length) { t = c; break; }
      }
      if (t) {
        e.preventDefault();
        var y = t.getBoundingClientRect().top + window.scrollY - 84;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
    }
    if (e.target.closest('[data-sp-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-sp-cart-close]') || e.target.closest('[data-sp-cart-overlay]')) closeCart();

    var qty = e.target.closest('[data-sp-qty]');
    if (qty) {
      e.preventDefault();
      var q = Number(qty.dataset.q), key = qty.dataset.key;
      if (q < 0 || !key) return;
      // Nut trong dong cua CUM GOI dieu khien ca goi: lay cum (co data-bundle-keys) lam row.
      // O so luong trong cum: [data-sp-deal-qty] dieu khien CA GOI (row = cum, co data-bundle-keys);
      // [data-sp-line-qty] la "mua N tang 1" tren cung san pham: row = dong tinh tien (co data-props/gift-keys).
      var isDealStep = !!qty.closest('[data-sp-deal-qty]');
      var isLineStep = !!qty.closest('[data-sp-line-qty]');
      // [data-sp-member-qty]: mot mon trong combo nhieu mon — chinh rieng cac line cua mon do (xem memberUpdates).
      var isMemberStep = !!qty.closest('[data-sp-member-qty]');
      var row = isDealStep ? qty.closest('[data-bundle-keys]') : qty.closest('.sp-cart__item');
      var down = Number(qty.dataset.dir) < 0;
      // San: goi = 1 bo; "mua N tang 1" = N (so luong them vao ban dau, doc tu luat deal da cache); bo thi dung Xoa.
      var floor = (isDealStep || isMemberStep) ? 1 : (isLineStep ? ((ruleFloor[key] && ruleFloor[key].buy) || 1) : 0);
      if ((isDealStep || isLineStep || isMemberStep) && q < floor) return;
      // Bấm − trên dòng của một ưu đãi ("Mua 2, Tặng 1"): dòng quà tặng nằm CHUNG
      // một line giỏ với dòng tính tiền, nên phải đặt quà về 0 trong cùng request.
      // Giảm mỗi dòng tính tiền thì tổng line chỉ bớt 1 → deal vỡ mà quà vẫn còn
      // trong line → hai dòng gộp lại thành 1 dòng số lượng cũ, giá gốc.
      // Chi tiết: snippets/spotless-cart-gift-keys.liquid
      var lineGifts = row && row.dataset.giftKeys ? row.dataset.giftKeys.split(',').filter(Boolean) : [];
      var bundlePairs = bundlePairsOf(row);
      // Optimistic: đổi số ngay lập tức, không chờ server; server render lại giá/subtotal sau
      var box = qty.closest('.sp-cart__qty');
      if (box) {
        var span = box.querySelector('span');
        if (span) span.textContent = q;
        var btns = box.querySelectorAll('[data-sp-qty]');
        if (btns[0]) { btns[0].dataset.q = Math.max(floor, q - 1); btns[0].disabled = (isDealStep || isLineStep || isMemberStep) && q <= floor; }
        if (btns[1]) btns[1].dataset.q = q + 1;
        if (q === 0 && row) row.style.opacity = '.35';
        // Lam mo gia dong va tong ngay khi bam: Shopify mat ~1,4s chay lai discount cua Kaching;
        // HTML moi thay the toan bo nen hieu ung tu het khi response ve.
        if (row) Array.prototype.forEach.call(row.querySelectorAll('.sp-cart__item-price'), function (p) { p.classList.add('is-updating'); });
        var foot = document.querySelector('[data-sp-cart] .sp-cart__foot');
        if (foot) foot.classList.add('is-updating');
      }
      // Làm mờ dòng quà khi bấm −, và bỏ mờ khi đổi ý bấm + trong lúc còn debounce.
      // So key bằng dataset thay vì dựng selector để không phải lo escape.
      Array.prototype.forEach.call(document.querySelectorAll('.sp-cart__item--gift'), function (giftRow) {
        if (lineGifts.indexOf(giftRow.dataset.key) !== -1) giftRow.style.opacity = down ? '.35' : '';
      });
      // Bỏ combo thì cả gói biến mất, làm mờ hết cho khách thấy trước
      if (q === 0 && bundlePairs.length) {
        var bundleKeys = bundlePairs.map(function (p) { return p.slice(0, p.lastIndexOf('|')); });
        Array.prototype.forEach.call(document.querySelectorAll('.sp-cart__item'), function (r) {
          if (bundleKeys.indexOf(r.dataset.key) !== -1) r.style.opacity = '.35';
        });
      }
      // Debounce theo o so luong: bam nhanh lien tiep chi gui 1 request voi so cuoi cung.
      var qtyId = box && box.dataset.spQtyId ? box.dataset.spQtyId : key;
      clearTimeout(qtyTimers[qtyId]);
      qtyTimers[qtyId] = setTimeout(function () {
        if (qtyInFlight) { qtyPending = { id: qtyId, q: q }; return; }
        runQtyUpdate(qtyId, q);
      }, 120);
    }
  });

  // AJAX add-to-cart: mọi form action /cart/add (trừ form có data-sp-no-ajax)
  if (!delegated) document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]') || form.hasAttribute('data-sp-no-ajax')) return;
    e.preventDefault();
    var fd = new FormData(form);
    fd.append('sections', CART_SECTION);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (data) {
        if (applyCartHtml(data.sections && data.sections[CART_SECTION])) openCart();
        else return refreshCart(true);
      })
      .catch(function () { form.submit(); });
  });

  /* ---- 5. Reveal on scroll (khớp React <Reveal>: fade + rise 12px, .4s ease-out,
     IO threshold .12 rootMargin -6%, once; reduced-motion → hiện ngay) ---- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -20% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- 6. View transitions: dedupe view-transition-name — cùng 1 sản phẩm
     xuất hiện 2 lần trên trang (vd cart cross-sell + search) làm trùng tên
     → trình duyệt bỏ qua toàn bộ transition. Giữ lần xuất hiện đầu tiên. ---- */
  function dedupeViewTransitionNames() {
    var seen = {};
    document.querySelectorAll('[style*="view-transition-name"]').forEach(function (el) {
      var n = el.style.viewTransitionName;
      if (!n || n === 'none') return;
      if (seen[n]) el.style.viewTransitionName = 'none';
      else seen[n] = true;
    });
  }


  /* ---- 7. Lightbox ảnh PDP — click ảnh trong gallery để xem lớn.
     Shell = snippet spotless-lightbox (rỗng); ảnh nạp từ gallery của section khi mở,
     nên dùng chung được cho cả product-main lẫn product-simple. ---- */
  function initLightbox() {
    var lb = document.querySelector('[data-sp-lightbox]');
    if (!lb) return;
    var imgEl = lb.querySelector('[data-lb-img]');
    var frame = lb.querySelector('[data-lb-frame]');
    var countEl = lb.querySelector('[data-lb-count]');
    var thumbsEl = lb.querySelector('[data-lb-thumbs]');
    var items = [], cur = 0, gallery = null, lastFocus = null, closeT = 0;
    var z = 1, ox = 0, oy = 0, ZMAX = 2.6;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function apply(anim) {
      imgEl.style.transition = (anim && !reduce) ? 'transform .28s var(--ease-out)' : 'none';
      imgEl.style.transform = 'translate(' + ox + 'px,' + oy + 'px) scale(' + z + ')';
      lb.classList.toggle('is-zoom', z > 1.01);
    }
    function clampPan() {
      var r = frame.getBoundingClientRect();
      var mx = Math.max(0, (imgEl.clientWidth * z - r.width) / 2);
      var my = Math.max(0, (imgEl.clientHeight * z - r.height) / 2);
      ox = Math.min(mx, Math.max(-mx, ox)); oy = Math.min(my, Math.max(-my, oy));
    }
    function zoomTo(nz, cx, cy) {
      var r = frame.getBoundingClientRect();
      nz = Math.min(ZMAX, Math.max(1, nz));
      var px = (cx - r.left - r.width / 2), py = (cy - r.top - r.height / 2);
      if (nz === 1) { ox = 0; oy = 0; }
      else { ox = px * (1 - nz); oy = py * (1 - nz); }
      z = nz; clampPan(); apply(true);
    }
    function resetZoom() { z = 1; ox = 0; oy = 0; apply(false); }

    function setIdx(i) {
      var n = items.length; if (!n) return;
      cur = ((i % n) + n) % n;
      imgEl.style.opacity = '0';
      imgEl.src = items[cur].full;
      imgEl.alt = items[cur].alt || '';
      countEl.textContent = (cur + 1) + ' / ' + n;
      thumbsEl.querySelectorAll('.sp-lb__thumb').forEach(function (t, k) {
        t.classList.toggle('is-active', k === cur);
      });
      resetZoom();
    }
    imgEl.addEventListener('load', function () { imgEl.style.opacity = '1'; });

    function open(g, i) {
      gallery = g;
      var slides = g.querySelectorAll('img[data-i]');
      items = [];
      slides.forEach(function (s) {
        items.push({ full: s.getAttribute('data-full') || s.currentSrc || s.src, thumb: s.currentSrc || s.src, alt: s.getAttribute('alt') });
      });
      if (!items.length) return;
      thumbsEl.innerHTML = '';
      items.forEach(function (it, k) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'sp-lb__thumb'; b.setAttribute('aria-label', 'Ảnh ' + (k + 1));
        var im = document.createElement('img'); im.src = it.thumb; im.alt = '';
        b.appendChild(im);
        b.addEventListener('click', function () { setIdx(k); });
        thumbsEl.appendChild(b);
      });
      lb.classList.toggle('is-single', items.length < 2);
      lastFocus = document.activeElement;
      clearTimeout(closeT);
      lb.hidden = false;
      document.body.classList.add('sp-lb-open');
      setIdx(i);
      requestAnimationFrame(function () { lb.classList.add('is-open'); });
      var x = lb.querySelector('.sp-lb__icon'); if (x) x.focus();
    }
    function close() {
      lb.classList.remove('is-open');
      document.body.classList.remove('sp-lb-open');
      /* Trả gallery của section về đúng ảnh đang xem: bấm thumb tương ứng để dùng lại setActive của section */
      if (gallery) {
        var t = gallery.querySelector('button[data-i="' + cur + '"]');
        if (t) t.click();
      }
      closeT = setTimeout(function () { lb.hidden = true; imgEl.removeAttribute('src'); }, 280);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* Mở 1 ảnh đơn lẻ (vd nút So sánh của switch phiên bản): phần tử có [data-lb-single]="URL ảnh" */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-lb-single]');
      if (!t) return;
      e.preventDefault();
      gallery = null;
      var src = t.getAttribute('data-lb-single');
      items = [{ full: src, thumb: src, alt: t.getAttribute('aria-label') || '' }];
      thumbsEl.innerHTML = '';
      lb.classList.add('is-single');
      lastFocus = document.activeElement;
      clearTimeout(closeT);
      lb.hidden = false;
      document.body.classList.add('sp-lb-open');
      setIdx(0);
      requestAnimationFrame(function () { lb.classList.add('is-open'); });
      var x = lb.querySelector('.sp-lb__icon'); if (x) x.focus();
    });

    /* Mở: click stage hoặc nút kính lúp. Bỏ qua click sinh ra từ cú vuốt. */
    var swipedAt = 0;
    document.addEventListener('touchend', function (e) {
      var t = e.target.closest && e.target.closest('[data-lb-open]');
      if (t && t.dataset.spMoved === '1') { swipedAt = Date.now(); t.dataset.spMoved = '0'; }
    }, true);
    document.addEventListener('touchstart', function (e) {
      var t = e.target.closest && e.target.closest('[data-lb-open]');
      if (t) { t.dataset.spX = e.touches[0].clientX; t.dataset.spMoved = '0'; }
    }, { capture: true, passive: true });
    document.addEventListener('touchmove', function (e) {
      var t = e.target.closest && e.target.closest('[data-lb-open]');
      if (t && Math.abs(e.touches[0].clientX - parseFloat(t.dataset.spX || 0)) > 12) t.dataset.spMoved = '1';
    }, { capture: true, passive: true });

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-lb-open]');
      if (!t || Date.now() - swipedAt < 400) return;
      var g = t.closest('[data-gallery]'); if (!g) return;
      e.preventDefault();
      var act = g.querySelector('img[data-i].is-active');
      var i = act ? parseInt(act.getAttribute('data-i'), 10) : 0;
      open(g, i || 0);
    });

    lb.querySelectorAll('[data-lb-close]').forEach(function (b) { b.addEventListener('click', close); });
    lb.querySelector('[data-lb-prev]').addEventListener('click', function () { setIdx(cur - 1); });
    lb.querySelector('[data-lb-next]').addEventListener('click', function () { setIdx(cur + 1); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') setIdx(cur - 1);
      else if (e.key === 'ArrowRight') setIdx(cur + 1);
    });

    /* Click ảnh = phóng to / thu nhỏ tại điểm bấm; kéo để di khi đang phóng */
    var down = false, sx = 0, sy = 0, bx = 0, by = 0, moved = false, pinch = 0, pz = 1;
    imgEl.addEventListener('click', function (e) { e.stopPropagation(); });
    frame.addEventListener('pointerdown', function (e) {
      if (e.target !== imgEl) return;
      down = true; moved = false; sx = e.clientX; sy = e.clientY; bx = ox; by = oy;
      frame.setPointerCapture(e.pointerId);
    });
    frame.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
      if (z > 1.01) { ox = bx + dx; oy = by + dy; clampPan(); apply(false); }
    });
    frame.addEventListener('pointerup', function (e) {
      if (!down) return; down = false;
      var dx = e.clientX - sx;
      if (!moved && e.target === imgEl) { zoomTo(z > 1.01 ? 1 : 2.2, e.clientX, e.clientY); return; }
      /* Vuốt ngang khi chưa phóng = đổi ảnh */
      if (z <= 1.01 && Math.abs(dx) > 60 && items.length > 1) setIdx(cur + (dx < 0 ? 1 : -1));
    });
    frame.addEventListener('pointercancel', function () { down = false; });
    /* Chụm 2 ngón để phóng */
    frame.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 2) return;
      down = false;
      pinch = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
      pz = z;
    }, { passive: true });
    frame.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 2 || !pinch) return;
      var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
      z = Math.min(ZMAX, Math.max(1, pz * (d / pinch)));
      clampPan(); apply(false);
    }, { passive: true });
    frame.addEventListener('touchend', function (e) { if (e.touches.length < 2) pinch = 0; if (z <= 1.01) resetZoom(); });
    frame.addEventListener('click', function (e) { if (e.target === frame) close(); });
  }

  /* ---- 8. Cac link tro toi khu danh gia -> cuon muot, tru chieu cao header dinh.
     (Khong dung scrollIntoView de tu kiem soat offset.)
     Gom: "N danh gia" o PDP, va nut "Xem tat ca anh & video" o khu social proof —
     nut do co href="#pdp-reviews" tro toi section VIDEO; nhung dung y la xuong khu
     DANH GIA, nen de handler nay uu tien #jdgm-reviews (xem dong ben duoi).
     Href giu nguyen lam duong lui khi trang khong co section danh gia Judge.me. ---- */
  function initReviewAnchor() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.spm-rev, .spsimple__rating, .sp-sproof__more');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      /* Uu tien section danh gia Judge.me khi trang co no; khong thi theo href. */
      var t = document.getElementById('jdgm-reviews') || document.getElementById(href.slice(1));
      if (!t) return;
      e.preventDefault();
      var hEl = document.querySelector('[data-sp-header], .sp-header, header');
      var hdr = hEl ? hEl.offsetHeight : 64;
      var y = t.getBoundingClientRect().top + window.scrollY - hdr - 20;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      if (history.replaceState && t.id) history.replaceState(null, '', '#' + t.id);
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    document.querySelectorAll('[data-sp-rail]').forEach(initRail);
    initHeader();
    initReveal();
    initLightbox();
    initReviewAnchor();
    dedupeViewTransitionNames();
    fillDealTitles();
  });
})();
